export const shouldForwardProp = (propName: string): boolean =>
  propName !== 'ownerState' && propName !== 'as' && propName !== 'sx';

export const makeShouldForwardProp = (...propNames: string[]) => {
  return (propName: string): boolean =>
    shouldForwardProp(propName) && !propNames.includes(propName);
};
